import { render, staticRenderFns } from "./ClassTrialBehaviorTable.vue?vue&type=template&id=cdcf49c6"
import script from "./ClassTrialBehaviorTable.vue?vue&type=script&lang=js"
export * from "./ClassTrialBehaviorTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports